import { gql } from '@apollo/client';

export default gql`
  query Topics($excludedTopicId: [String!]!) {
    topicsCollection(
      where: {
        sys: { id_not_in: $excludedTopicId }
        reviewStatus: "Accepted"
        userRating_exists: true
        type_in: ["Minor", "Major"]
      }
      order: [userRating_DESC]
    ) {
      items {
        title
        slug
        sys {
          id
        }
      }
    }
  }
`;
